import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { Spin } from "antd";
import { useAppSelector } from "@/services/store";
import { NoContactsPage } from "../Components/NoContactsPage";
import { ContactsMobileList } from "../Components/ContactsMobileList";
import { contactsIsEditSelector } from "../slice";
import { Header } from "../Components/Header";
import { useContactsPageDesktop } from "../desktop/use-contacts-page-desktop";
import { isPersonSelected } from "../helpers";
import styles from "./styles.module.scss";

export const ContactsPageMobile = () => {
  const { t } = useTranslation();

  const personSelected = isPersonSelected();

  const { state, methods } = useContactsPageDesktop();
  const { filteredContacts, isError, isLoading, sorter, swipedPerson } = state;
  const { setMenuSorter, handleSwipedPerson } = methods;

  const isEdit = useAppSelector(contactsIsEditSelector);

  if (isLoading) {
    return (
      <div className={styles["loader"]}>
        <Spin size="large" />
      </div>
    );
  }

  if (isError) {
    return <div>{t("common.error")}</div>;
  }

  return (
    <div
      className={classNames(styles.container, {
        [styles["container-no-contacts"]]: !filteredContacts.length && !isEdit,
      })}
    >
      <Header setSorter={setMenuSorter} showSorter={!personSelected} sorter={sorter} />
      {(!filteredContacts || !filteredContacts.length) && !isEdit && (
        <NoContactsPage message={t("contactsPage.noContacts")} isAddContact isImportEnabled />
      )}
      {!personSelected && (
        <ContactsMobileList
          persons={filteredContacts.map((item) => item.person)}
          setSwipedPerson={handleSwipedPerson}
          swipedPerson={swipedPerson}
        />
      )}
      <Outlet />
    </div>
  );
};
